export const SCORES_MIN_LENGTH = 1;
export const OPTIONS_MIN_LENGTH = 2;
export const OPTIONS_MAX_LENGTH = 12;
export const SCORE_MIN_VALUE = 1;
export const SCORE_MAX_VALUE = 12;
